<form [formGroup]="form" class="search__flightHotel" novalidate>
  <div class="section__flightHotel__tags">
    <app-input-class [includeFirtClass]="false" [isLeft]="true" #childClass></app-input-class>
    <app-pop-up-pasajero
      #popUp
      (emitDistribution)="distribution = $event"
      (emitDistributionObject)="distributionObject = $event"
      [nroAdultos]="2"
    ></app-pop-up-pasajero>
  </div>

  <div class="section__flightHotel__inputs">
    <section>
      <div class="section__flightHotel__inputs__group">
        <app-autocomplete-dropdown
          #originAutocomplete
          (selectItem)="onOrigenSelect($event)"
          [control]="origin"
          [showClearInput]="false"
          [showLoader]="state.origin.loading"
          [suggestions]="state.origin.suggestions"
          id="origen-autocomplete"
          placeholder="Origen"
        ></app-autocomplete-dropdown>
      </div>

      <div class="section__flightHotel__inputs__group">
        <app-autocomplete-dropdown
          #destinationAutocomplete
          (selectItem)="onDestinationSelect($event)"
          [control]="destination"
          [showClearInput]="false"
          [showLoader]="state.destination.loading"
          [suggestions]="state.destination.suggestions"
          id="destination-autocomplete"
          placeholder="Destino"
        ></app-autocomplete-dropdown>
      </div>
    </section>

    <app-input-range #childDates [typeFlight]="-1"></app-input-range>

    <app-button
      (buttonClick)="searchVueloHotel()"
      [isDisabled]="state.origin.loading || state.destination.loading"
      [isFullWidth]="true"
      buttonClass="px-4"
      buttonId="btn-search-packages"
      title="Buscar"
    >
      <i aria-label="Buscar" class="custom-icon icon-search"></i>
      <span class="d-lg-none ms-2">Buscar</span>
    </app-button>
  </div>
</form>
